import { useEffect, useState } from "react"
import { baseUrl } from "../../../../Config"

const VotersGroupOrigin = ({ title, link, votes, type, }) => {

    const [party, setParty] = useState(null)
    const [commision, setCommision] = useState(null)
    const [cincun, setCincun] = useState(null)
    const [voteType, setVoteType] = useState(null)
    const [member, setMember] = useState(null)

    const [modalId] = useState(`voters-modal-${Math.random().toString(36).substring(2, 11)}`);

    useEffect(() => {
        if (type === 'yes') {
            setVoteType('Si');
        } else if (type === 'no') {
            setVoteType('No');
        } else if (type === 'na') {
            setVoteType('N/A');
        }
    }, [type]);

    const getProgressColor = (value) => {
        if (value >= 0 && value <= 30) {
            return '#C60A15';
        } else if (value > 30 && value <= 60) {
            return '#FFB800';
        } else {
            return '#068340';
        }
    }

    useEffect(() => {
        var popoverTriggerList = [].slice.call(document.querySelectorAll('.voting-cage [data-bs-toggle="popover"]'))
        popoverTriggerList.map(function (popoverTriggerEl) {
            return new bootstrap.Popover(popoverTriggerEl) // eslint-disable-line
        })
    }, [])

    const openVotersModal = (member) => {
        console.log(member)
        setParty(member.party.name)
        setCommision(member.comission)
        setCincun(member.cincun)
        setMember(member)

        const votersModal = new bootstrap.Modal(document.getElementById(modalId)); // eslint-disable-line
        votersModal.show();
    };

    return <>
        <div className="voting-cage">
            <div className="d-flex justify-content-between align-items-center mb-3" style={{ borderBottom: '1px solid #1A3E58', paddingBottom: 5 }}>
                <p className="voting-cage-title mb-0">{ title } ({ votes.length })</p>

                { type === 'yes' && (
                    <img src="./assets/images/check.svg" />
                )}

                { type === 'no' && (
                    <img src="./assets/images/close.svg" />
                )}

                { type === 'no-vote' && (
                    <img src="./assets/images/no-vote.svg" />
                )}

                { type === 'excuse' && (
                    <img src="./assets/images/excuse.svg" />
                )}
            </div>

            <div className="voters">
                { votes.map(vote => (
                    // <img key={vote.id} src={`${baseUrl}/members/${vote.member?.photo}`} data-bs-toggle="popover" data-bs-placement="top" data-bs-html="true" data-bs-trigger="hover focus" data-bs-content={`${vote.member.name}`} className="authorimg" alt="Author Avatar" />
                    <img key={vote.id} src={`${baseUrl}/members/${vote.member?.photo}`} onClick={() => openVotersModal(vote.member)} className="authorimg" alt="Author Avatar" />
                ))}

                { votes.length === 0 && (
                    <p className="mb-0">Sin votos</p>
                )}
            </div>
        </div>

        <div className="modal fade" id={modalId} style={{zIndex: 9999999}} tabIndex="-1" aria-labelledby="votersModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="votersModalLabel">Detalles del miembro</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="member-info my-3">
                            <div className="d-flex flex-column align-items-center mb-4">
                                <div className="progress mt-2" style={{ width: '100%' }}>
                                    <div className="progress-bar" role="progressbar" style={{width: `${member?.progress}%`, backgroundColor: getProgressColor(member?.progress)}} aria-valuenow={member?.progress} aria-valuemin="0" aria-valuemax="100"></div>
                                </div>

                                <div className="d-flex justify-content-between align-items-center mt-2 mb-3" style={{ width: '100%' }}>
                                    <label className="progress-indicator">{member?.progress}/100</label>
                                </div>

                                <img src={`${baseUrl}/members/${member?.photo}`} style={{ width: 100, height: 100, borderRadius: '50%', objectFit: 'cover' }} alt="Author Avatar" />

                                <div className="mt-3 text-center">
                                    <h5 className="mb-0">{ member?.name }</h5>
                                    <p className="mb-0">{ member?.position }</p>
                                    <p className="mb-0">{ member?.party?.name }</p>
                                </div>
                            </div>

                            <table className="w-100">
                                <tbody>
                                    <tr>
                                        <td>Partido Político</td>
                                        <td>{ party }</td>
                                    </tr>
                                    <tr>
                                        <td>Periodo constitucional</td>
                                        <td>2022 - 2026</td>
                                    </tr>
                                    <tr>
                                        <td>Comisión</td>
                                        <td>{ commision }</td>
                                    </tr>
                                    <tr>
                                        <td>Circunscripción</td>
                                        <td>{ cincun }</td>
                                    </tr>
                                    <tr>
                                        <td>Votación</td>
                                        <td>
                                            { type === 'yes' && (
                                                'Si'
                                            )}

                                            { type === 'no' && (
                                                'No'
                                            )}

                                            { type === 'na' && (
                                                'N/A'
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </>
}

export default VotersGroupOrigin